import "./styles.css";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const TextEditorDropDown = ({
  value,
  icon,
  array,
  onClick,
}: {
  value: string;
  icon: boolean;
  array: [string, string][];
  onClick: (e: string) => void;
}) => {
  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          color="dark"
          className={`mr-2 p-1`}
          style={{
            cursor: "pointer",
            fontSize: ".87rem",
          }}
        >
          {icon ? <span className={`item-${value}`}></span> : <span>{value}</span>}
        </DropdownToggle>
        <DropdownMenu className="editor-dropdown-menu">
          {array.map(([option, text]) => (
            <DropdownItem
              key={option}
              className="editor-dropdown-item my-2"
              onClick={(e) => onClick(option)}
            >
              {icon && <span className={`item-${option}`}></span>}
              {text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default TextEditorDropDown;
